<template>
    <el-button type="primary" round class="appbtn" @click="showApp">打开APP，看更多精彩视频</el-button>
</template>

<script>
export default {
    name:'About',
    methods:{
        showApp(){
            this.$router.push({
                path: "/share/1549722813191884800"
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/About.vue